import { useWireAuth } from './useWireAuth'
import { workflowGroups } from './workflowGroups'

/**
 * Frontend-only authorization hook.
 *
 * Derives UI permissions from the authenticated user's group membership.
 * Use these flags to control visibility of buttons, dropdown options, and
 * workflow actions. The real authorization enforcement lives on the backend.
 */
export function useAuthz() {
  const { user } = useWireAuth()

  const groups: string[] = user?.uiasgroups ?? []

  return {
    isQualityControl:   groups.includes(workflowGroups.qualityControl),
    isLayoutAndDesign:  groups.includes(workflowGroups.layoutAndDesign),
    isEditorialManager: groups.includes(workflowGroups.editorialManager),
    isPostProduction:   groups.includes(workflowGroups.postProduction),

    /** True if the user belongs to any of the four workflow roles. */
    isWorkflowMember:
      groups.includes(workflowGroups.qualityControl)   ||
      groups.includes(workflowGroups.layoutAndDesign)  ||
      groups.includes(workflowGroups.editorialManager) ||
      groups.includes(workflowGroups.postProduction),

    /** Escape hatch for checking an arbitrary group name. */
    hasGroup: (group: string) => groups.includes(group),
  }
}
